import { createEvent, createStore, restore, sample } from 'effector'
import { fx } from 'src/libs'
import {
  NotificationPayload,
  showNotification,
} from 'src/pages/goldenMay2026/model'
import { buildQuery, ListRequest } from 'src/pages/goldenMay2026/utils'
import { BanRequest, Participant, ParticipantListResponse } from './types'

export const onChangeParticipantsList = createEvent<Partial<ListRequest>>()

export const getParticipantsFx = fx<ListRequest, ParticipantListResponse>({
  method: 'GET',
  url: `/promo/golden_may_2026/participant`,
})

export const banClientFx = fx<BanRequest, void>({
  method: 'PUT',
  url: `/promo/golden_may_2026/participant/{clientId}`,
})

export const $participants = createStore<Participant[]>([]).on(
  getParticipantsFx.doneData,
  (_, res) => res.body.items,
)

export const $totalCountOfParticipants = restore(
  getParticipantsFx.doneData.map((a) => a.body.total),
  0,
)

export const $participantsParams = createStore<ListRequest>({
  page: 1,
  limit: 10,
  orderBy: '',
  orderDirection: '',
  searchText: {},
  filters: {},
}).on(onChangeParticipantsList, (state, payload) => ({ ...state, ...payload }))

sample({
  clock: $participantsParams,
  fn: buildQuery,
  target: getParticipantsFx,
})

sample({
  clock: banClientFx.done,
  source: $participantsParams,
  fn: buildQuery,
  target: getParticipantsFx,
})

sample({
  clock: [getParticipantsFx.failData, banClientFx.failData],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Error',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: banClientFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Client disqualified',
  }),
  target: showNotification,
})
